export default __webpack_public_path__ + "static/media/home.37c4545d.svg";